import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import CloudflareTurnstile from "react-turnstile";

const MockTurnstile = ({ onVerify }) => {
  useEffect(() => onVerify("mock-token"), [onVerify]);

  return null;
};

MockTurnstile.propTypes = {
  onVerify: PropTypes.func.isRequired,
};

const Turnstile = ({ enabled, visible, ...rest }) => {
  const Component = enabled ? CloudflareTurnstile : MockTurnstile;

  return (
    <Component
      appearance="interaction-only"
      sitekey={env.TURNSTILE_SITE_KEY}
      style={visible ? {} : { display: "none" }}
      theme="light"
      {...rest}
    />
  );
};

Turnstile.propTypes = {
  enabled: PropTypes.bool.isRequired,
  visible: PropTypes.bool.isRequired,
};

export const useTurnstile = ({ onError }) => {
  const [token, setToken] = useState();
  const [visible, setVisible] = useState(false);
  const errorCounts = useRef({});

  const handleBeforeInteractive = () => setVisible(true);

  const handleError = (code) => {
    const errorCount = errorCounts.current[code] || 0;
    errorCounts.current[code] = errorCount + 1;

    if (errorCount < 4) {
      return false;
    }

    onError(code);

    return true;
  };

  return {
    turnstileToken: token,
    turnstileVisible: visible,
    turnstileHandlers: {
      onVerify: setToken,
      onBeforeInteractive: handleBeforeInteractive,
      onError: handleError,
    },
  };
};

export default Turnstile;
